export default {
  meta: {
    title: '周边配套',
    url: '/iterate/neighborhood', // 埋点字段，上报归属的模块
    urlName: '周边配套' // 埋点字段，上报归属的模块
  }
};
